module.exports = __webpack_public_path__ + "img/pwoot.6232c9f3.png";